import axios from 'axios'


const downloadAPI = async (basvuruId, filename) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/basvuru/download/${basvuruId}/${filename}`, {
        responseType: 'blob',
        headers: {
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        }
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    return response;
};
export default downloadAPI;